import { styled } from 'mz-ui-kit';

export const LightboxWrapper = styled('div', {
  padding: '20px',
});

export const LoadingWrapper = styled('div', {
  textAlign: 'center',
});

export const ButtonWrapper = styled('div', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginTop: '20px',
});
